import React from 'react'
import { PROMPT_PREQUAL } from 'src/constants/messages'
import Email from 'src/Components/shared/Email'

const PrequalContactEmailLink = ({ name, email, intl }) => (
  <Email
    text={intl.formatMessage(PROMPT_PREQUAL.email_link, { name })}
    value={email}
    data-qa='PrequalContactEmailLink'
  />
)

export default PrequalContactEmailLink
